import { useTranslation } from 'react-i18next';
import { Navigate, useParams } from 'react-router-dom';

import {
    Button,
    HtmlContent,
    Stack,
    Subtitle1,
} from '@myphx-engineering/phx-design-system';

import type { FillPathway } from '../../../contexts/fill';
import { useGoBack } from '../../../hooks/use-go-back';
import { useProgramTermsByDrugKey } from '../../../hooks/use-program-terms';
import type { DrugKeyType } from '../../../util/config/constants';
import { getAbsoluteRoute } from '../../../util/get-absolute-route';

export const DrugProgramTerms = () => {
    const { drugKey, pathway } = useParams();
    const { t } = useTranslation('lilly');

    const goBack = useGoBack();

    const terms = useProgramTermsByDrugKey(
        (drugKey ?? '') as DrugKeyType,
        (pathway ?? '') as FillPathway
    );

    if (!terms) {
        return <Navigate to={getAbsoluteRoute('notFound')} />;
    }

    return (
        <Stack gap="xl">
            <Subtitle1>{terms.heading}</Subtitle1>
            <HtmlContent content={terms.body} />
            <Button onClick={goBack}>
                {t('programs.pathway.terms.backBtn')}
            </Button>
        </Stack>
    );
};
